import React from "react";
import Records from "../Teachers.json";
import "../../Styling/Layout.css";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CardActions,
  CardMedia,
  Button,
  Box,
} from "@mui/material";

const LiveClassComponent = () => {
  return (
    <Box
      container
      spacing={3}
      sx={{
        flexWrap: "wrap",
        display: "flex",
      }}
    >
      {Records.map((record) => {
        return (
          <>
            <Grid key={record.teacher_id}>
              <Card
                sx={{
                  width: 283,
                  height: 360,
                  marginTop: 10,
                  marginLeft: "75px",
                  marginBottom: 10,
                }}
              >
                <CardMedia
                  sx={{ height: 200 }}
                  image={record.profile_pic}
                  title={record.first_name}
                />
                <CardContent sx={{ height: 70 }}>
                  <Typography gutterBottom variant="h7" component="div">
                    <b>
                      {record.first_name}  ( ₹{record.user_cost_per_unit} per hour )</b>
                    
                    
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="h7"
                    component="div"
                  ></Typography>
                  <Typography variant="body2" color="text.secondary">
                    {record.teacher_bio.length > 60
                      ? record.teacher_bio.substring(0, 60) + "..."
                      : record.teacher_bio}
                  </Typography>
                </CardContent>
                <CardActions sx>
                  <Button size="small">
                    <a href={record.meeting_link}> Book a class</a>
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </>
        );
      })}
    </Box>
  );
};

export default LiveClassComponent;
